var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMore(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 4,
    viewBox: "0 0 12 4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.2 1.99961C2.2 1.66824 1.93137 1.39961 1.6 1.39961C1.26863 1.39961 1 1.66824 1 1.99961C1 2.33098 1.26863 2.59961 1.6 2.59961C1.93137 2.59961 2.2 2.33098 2.2 1.99961Z",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5999 1.99961C6.5999 1.66824 6.33127 1.39961 5.9999 1.39961C5.66853 1.39961 5.3999 1.66824 5.3999 1.99961C5.3999 2.33098 5.66853 2.59961 5.9999 2.59961C6.33127 2.59961 6.5999 2.33098 6.5999 1.99961Z",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9998 1.99961C10.9998 1.66824 10.7312 1.39961 10.3998 1.39961C10.0684 1.39961 9.7998 1.66824 9.7998 1.99961C9.7998 2.33098 10.0684 2.59961 10.3998 2.59961C10.7312 2.59961 10.9998 2.33098 10.9998 1.99961Z",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMore);
export default __webpack_public_path__ + "static/media/More.4a6378474825778d77ba9115b620d002.svg";
export { ForwardRef as ReactComponent };